import { useEffect, useState } from "react";
import DataHandlerHelper from "../../helpers/DataHandler.helper";
import clientsApi from "../../api/client/client";
import trainingTypeApi from "../../api/trainingType/trainingType";
import { ui } from "../../helpers/ui";

const InitClientsLogic = () => {
  const [clients, setClients] = useState<any[]>([]);
  const [selectedClient, setSelectedClient] = useState<any>();
  // id -> naziv tipa treninga, da i tipovi dodati kroz Usluge imaju naziv
  const [typeNames, setTypeNames] = useState<Record<number, string>>({});
  const [data, setData] = useState<any>({
    client: "",
  });

  const onChange = (event: any) => {
    setData(DataHandlerHelper.handleInputChange(event, { ...data }));
  };

  const loadClients = () => {
    clientsApi
      .getAll()
      .then((response) => {
        if (response.status === 200) {
          setClients(response.data);
        }
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  const selectClient = (client: any) => {
    // Zaštita od duplog klika: bez mutacije state niza
    if (selectedClient?.id === client.id) return;
    const rest = clients.filter((c: any) => c.id !== client.id);
    setClients(selectedClient !== undefined ? [...rest, selectedClient] : rest);
    clientsApi
      .getByIdWithPaymentsAndTrainingsAndHolidays(client.id)
      .then((response) => {
        if (response.status === 200) {
          setSelectedClient(response.data);
        }
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      });

    // setData({ ...data, client: "" });
  };

  const removeSelectedClient = (client: any) => {
    setSelectedClient(undefined);
    setClients([...clients, client]);
    setData({ ...data, client: "" });
  };

  useEffect(() => {
    loadClients();
    trainingTypeApi
      .getTrainingTypes()
      .then((response) => {
        if (response.status === 200) {
          const map: Record<number, string> = {};
          for (const tt of response.data ?? []) map[tt.id] = tt.name;
          setTypeNames(map);
        }
      })
      .catch(() => {
        // Nazivi padaju na ugradjenu mapu
      });
  }, []);

  return {
    selectedClient,
    clients,
    typeNames,
    data,
    onChange,
    selectClient,
    removeSelectedClient,
  };
};

export default InitClientsLogic;
